// extracted by css-extract-rspack-plugin
export default {"logo":"AdminLogo_logo__dhZCL","wordmark":"AdminLogo_wordmark__wpNMa"};